module.exports = __webpack_public_path__ + "static/media/design-logo4.cc583d9d.png";